"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _lodash = require("lodash");
var _helpers = require("./helpers");
function cov_26ljl62hx8() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/ThemeBuilder.js";
  var hash = "8379c4eadecb23c93715e6e8f94d9ccf661c300d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/ThemeBuilder.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 10
        },
        end: {
          line: 4,
          column: 23
        }
      },
      "1": {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 36
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 55
        }
      },
      "3": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 16
        }
      },
      "4": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 65
        }
      },
      "5": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 16
        }
      },
      "6": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 3
          }
        },
        loc: {
          start: {
            line: 7,
            column: 21
          },
          end: {
            line: 9,
            column: 3
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        loc: {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 23
          },
          end: {
            line: 19,
            column: 3
          }
        },
        line: 16
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 3
          }
        },
        loc: {
          start: {
            line: 21,
            column: 8
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 21
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8379c4eadecb23c93715e6e8f94d9ccf661c300d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_26ljl62hx8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_26ljl62hx8();
var _ = (cov_26ljl62hx8().s[0]++, {
  cloneDeep: _lodash.cloneDeep
});
var ThemeBuilder = exports.default = /*#__PURE__*/function () {
  function ThemeBuilder(theme) {
    (0, _classCallCheck2.default)(this, ThemeBuilder);
    cov_26ljl62hx8().f[0]++;
    cov_26ljl62hx8().s[1]++;
    this.theme = _.cloneDeep(theme);
  }
  return (0, _createClass2.default)(ThemeBuilder, [{
    key: "withBg",
    value: function withBg(bg) {
      cov_26ljl62hx8().f[1]++;
      cov_26ljl62hx8().s[2]++;
      this.theme = (0, _helpers.setThemeStyling)(this.theme, 'bg', bg);
      cov_26ljl62hx8().s[3]++;
      return this;
    }
  }, {
    key: "withTextColor",
    value: function withTextColor(color) {
      cov_26ljl62hx8().f[2]++;
      cov_26ljl62hx8().s[4]++;
      this.theme = (0, _helpers.setThemeStyling)(this.theme, 'textColor', color);
      cov_26ljl62hx8().s[5]++;
      return this;
    }
  }, {
    key: "get",
    value: function get() {
      cov_26ljl62hx8().f[3]++;
      cov_26ljl62hx8().s[6]++;
      return this.theme;
    }
  }]);
}();